/** Shared muted recap panels for between-turns “Last turn” cards (WWW + Hat). */
export const READY_RECAP_PANEL_CLASS =
  "rounded-lg border border-border bg-semantic-muted-panel-bg p-3 text-typ-ui shadow-sm";
